


import { Routes, RouterModule } from '@angular/router';
import { TemplateTextComponent } from './templatetext.component';

const routes: Routes = [
    {
        path: '',
        component: TemplateTextComponent
    },
];

export const TemplateTextRoutes = RouterModule.forChild(routes);
